import { Scope } from "@corpuscomplete/core/common/scope";
import { FoodCollectionUI } from "@corpuscomplete/core-ui/nutrition/food-collection";
import { RecipeList } from "@corpuscomplete/core-ui/nutrition/recipe/list";
import { useAuth } from "@corpuscomplete/web/auth/hooks";
import { RecipesPage } from "@corpuscomplete/web/modules/nutrition/recipe/pages/recipes";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { z } from "zod/v4";

export const Route = createFileRoute("/_authenticated/personal/recipes/")({
  validateSearch: z.object({
    collectionId: z.uuid().optional(),
  }),
  loaderDeps: ({ search: { collectionId } }) => ({ collectionId }),
  loader: async ({ context: { actor, zero }, deps: { collectionId } }) => {
    if (!zero) return;
    await RecipeList.preload(zero, { requestedCollectionId: collectionId, scopeId: actor.userId });
  },
  component: () => {
    const { collectionId: requestedCollectionId } = Route.useSearch();
    const { userId } = useAuth();
    const collections = FoodCollectionUI.useForContentManagement({ foodType: "recipe" }).filter(
      (collection) => collection.scopeId === userId,
    );
    const collectionId = FoodCollectionUI.resolveManagedCollectionId({
      requestedCollectionId,
      collections,
      foodType: "recipe",
    });

    if (collectionId !== requestedCollectionId) {
      return <Navigate to="/personal/recipes" search={{ collectionId }} replace />;
    }

    return <RecipesPage collectionId={collectionId} scope={Scope.personal(userId)} />;
  },
});
